import { SimpleMenu } from "@components";
import { useTranslation } from "react-i18next";

const MenuProfile = function ({ active }) {
  const { t } = useTranslation();

  return (
    <SimpleMenu
      title={t("struktur_manajemen")}
      active={active}
      menu={[
        {
          text: t("dewankomisaris"),
          link: "/structure-corporate/komisaris",
        },
        {
          text: t("dewandireksi"),
          link: "/structure-corporate/direksi",
        },
        {
          text: t("komite"),
          link: "/structure-corporate/komite",
        },
        {
          text: t("sekretaris_perusahaan"),
          link: "/structure-corporate/sekretarisperusahaan",
        },
        {
          text: t("struktur_organisasi"),
          link: "/structure-corporate/struktur-organisasi",
        },
      ]}
    />
  );
};
export default MenuProfile;
